import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { Row, Col, CardBody, Card } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import DataTable from 'react-data-table-component';
import BusinessService from "./Warehouse.service.js";
import AuthService from "../Authentication/auth.service.js";
import Alerts from "../../components/Alerts/alerts.js";
import { Tooltip } from "@mui/material";
import WarehouseFilter from "../../components/Table Filters/WarehouseFilter.js";
import AddWarehouse from "./AddWarehouse.js";
import UpdateWarehouse from "./EditWarehouse.js";
import PermissionAccess from '../../PermissionAccess/Access.js';

const TabAttribute = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [Warehouse, setWarehouse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchData(0, pageLimit, filterText, filterStatus);
  }, [pageLimit]);


  function fetchData(page_index, page_limit, filterText, filterStatus) {
    setLoading(true);
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    BusinessService.getAllWarehouse(authData.sessionID, offset, page_limit, filterStatus, filterText).then(
      (response) => {
        setLoading(false);
        //iph todo: 47
        //console.log("Get Warehouse response:-", response);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          //iph todo: 47
          //console.log(response.data);
          setWarehouse(response.data.data);
          setTotalRows(response.data.count.count);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      }
    );
  }

  const handleCheckboxChange = (e, row) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedRows((prevSelected) => [...prevSelected, row._id]);
    } else {
      setSelectedRows((prevSelected) => prevSelected.filter(id => id !== row._id));
    }
  };

  const handleSelectAllChange = (e) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedRows(Warehouse.map((attribute) => attribute._id));
    } else {
      setSelectedRows([]);
    }
  };


  const handleDeleteSelected = () => {
    if (selectedRows.length > 0) {
      let msg = t(selectedRows.length + " records selected. Once deleted, you will not be able to recover this!");
      Alerts.swalConfirmDeleteAlert(msg).then(res => {
        //iph todo: 47
        //console.log("Resp:-", res)
        if (res === true) {
          sendBulkDelete(selectedRows)
        }
      })
    } else {
      Alerts.swalErrorAlert('No records selected');
    }
  };

  function sendBulkDelete(selectedRows) {
    setLoading(true);
    BusinessService.DeleteBulkWarehouse(authData.sessionID, selectedRows).then((response) => {
      //iph todo: 47
      //console.log("Delete BulkWarehouse response:-", response)
      setLoading(false);
      setSelectedRows([]);
      fetchData(currentPage, pageLimit, filterText, filterStatus)
      if (response.data.status) {
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Data Deleted Successfully."))
        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        setLoading(false);
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't delete the Collection Data at the moment."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Delete operation failed"))
      })
  };

  const mycolumns = [
    {
      name: (
        <div>
          <input
            className="form-check-input"
            type="checkbox"
            onChange={handleSelectAllChange}
          />
        </div>
      ),
      width: '10%',
      selector: (row) => {
        return (
          <div>
            <input
              className="form-check-input"
              type="checkbox"
              checked={selectedRows.includes(row._id)}
              onChange={(e) => handleCheckboxChange(e, row)}
            />
          </div>
        );
      },
    },
    {
      name: t('Name'),
      selector: "name",
      width: "30%",
      sortable: true,
    },
    {
      name: t('Status'),
      width: '30%',
      selector: (row) => {
        return (
          <div>
            {row?.status?.toLowerCase() === "active" ? (
              <button
                type="button"
                style={{ borderColor: '#3ac47d', backgroundColor: '#1BD35A' }}
                className="btn btn-sm btn-success btn-hover-shine me-3"
              >
                {row.status}
              </button>
            ) : (
              <button
                type="button"
                style={{ borderColor: '#FF0000', backgroundColor: 'red' }}
                className="btn btn-sm btn-danger btn-hover-shine me-3"
              >
                {row.status}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: t('Actions'),
      width: "30%",
      selector: (row) => {
        return (
          <div>
            {/* {!super_admin ? current_module?.ViewDetails === 1 &&
              <Tooltip placement="top" title={`${t("Warehouse")} ${t("Details")}`} arrow>
                <Link to="/Warehouse-details" state={row}>
                  <i className="pe-7s-note2 btn-icon-wrapper text-info"> </i>
                </Link>
              </Tooltip >
              :
              <Tooltip placement="top" title={`${t("Warehouse")} ${t("Details")}`} arrow>
                <Link to="/Warehouse-details" state={row}>
                  <i className="pe-7s-note2 btn-icon-wrapper text-info"> </i>
                </Link>
              </Tooltip >
            } */}
            {!super_admin ? current_module?.EditData === 1 &&
              <Tooltip placement="top" title={`${t("Update")} ${t("Warehouse")}`} arrow>
                <i style={{ marginLeft: '10px', marginRight: '10px', cursor: 'pointer' }}>
                  <UpdateWarehouse data={row} onSuccess={handleSuccess} authData={authData} />
                </i>
              </Tooltip>
              :
              <Tooltip placement="top" title={`${t("Update")} ${t("Warehouse")}`} arrow>
                <i style={{ marginLeft: '10px', marginRight: '10px', cursor: 'pointer' }}>
                  <UpdateWarehouse data={row} onSuccess={handleSuccess} authData={authData} />
                </i>
              </Tooltip>
            }
            {!super_admin ? current_module?.DeleteData === 1 &&
              <Tooltip placement="top" title={`${t("Delete")} ${t("Warehouse")}`} arrow>
                <a className="DeletetData" onClick={() => confirmDelete(row._id)} style={{ cursor: "pointer" }}>
                  <i className="pe-7s-trash text-danger btn-icon-wrapper fs-5"> </i>
                </a>
              </Tooltip>
              :
              <Tooltip placement="top" title={`${t("Delete")} ${t("Warehouse")}`} arrow>
                <a className="DeletetData" onClick={() => confirmDelete(row._id)} style={{ cursor: "pointer" }}>
                  <i className="pe-7s-trash text-danger btn-icon-wrapper fs-5"> </i>
                </a>
              </Tooltip>
            }
          </div>
        );
      }
    },
  ];


  const handleSearch = (searchText, status) => {
    setFilterText(searchText);
    setFilterStatus(status);
    fetchData(0, pageLimit, searchText, status);
  };

  const handleClear = () => {
    setFilterText('');
    setFilterStatus('');
    fetchData(0, pageLimit, '', '');
  };

  const filteredItems = Warehouse.filter(
    item =>
      (item?.name?.toLowerCase().includes(filterText?.toLowerCase())
      ) &&
      (filterStatus === '' || item.status === filterStatus)
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <WarehouseFilter
        onSearch={handleSearch}
        onClear={handleClear}
        filterText={filterText}
        filterStatus={filterStatus}
      />
    );
  }, [filterText, filterStatus]);


  function handlePageChange(page_index) {
    //iph todo: 47
    //console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchData(page_index, pageLimit, filterText, filterStatus);
  }


  function confirmDelete(_id) {
    let msg = t("Once deleted, you will not be able to recover!")
    Alerts.swalConfirmDeleteAlert(msg).then(res => {
      //iph todo: 47
      //console.log("Resp:-", res)
      if (res === true) {
        sendDelete(_id)
      }
    })
  };
  function handleSuccess() {
    fetchData(0, pageLimit, filterText, filterStatus);
  };
  function sendDelete(id) {
    setLoading(true);
    BusinessService.deleteVariation(authData.sessionID, id).then((response) => {
      //iph todo: 47
      //console.log("Delete Variation response:-", response)
      setLoading(false);
      fetchData(currentPage, pageLimit, filterText, filterStatus)
      if (response.data.status) {
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Data Deleted Successfully."))
        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        setLoading(false);
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't delete the Attribute."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Delete operation failed"))
      })
  };
  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }

  return (
    <Fragment>
      <Col md="12" className="mx-auto app-login-box">

        <Row>
          <LoadingOverlay
            tag="div"
            active={loading}
            styles={{ overlay: (base) => ({ ...base }) }}
            spinner={<DNALoader />}
          >
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <Col md="6" style={{ float: "left", position: "absolute", zIndex: "1" }}>
                    {subHeaderComponentMemo}
                  </Col>
                  <DataTable
                    data={Warehouse}
                    columns={mycolumns}
                    pagination
                    fixedHeader
                    fixedHeaderScrollHeight="400px"
                    subHeader
                    subHeaderComponent={
                      <div>
                        <button type="button"
                          className="btn btn-outline-danger btn-hover-shine me-3 btn"
                          onClick={handleDeleteSelected}
                        >
                          {t('Delete Selected')}
                        </button>

                        {!super_admin ? current_module?.AddData === 1 &&
                          <AddWarehouse onSuccess={handleSuccess} authData={authData} />
                          :
                          <AddWarehouse onSuccess={handleSuccess} authData={authData} />
                        }
                      </div>
                    }
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationResetDefaultPage={resetPaginationToggle}
                  />

                </CardBody>
              </Card>
            </Col>
          </LoadingOverlay>
        </Row>
      </Col>
    </Fragment>
  );
};

export default TabAttribute;
